import { Component, OnInit } from '@angular/core';
import { SubcarrierService } from '~services/subcarrier.service';
import { SubcarrierVendorContracts } from '~models/subcarrier.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'sa-subcarrier-vendor-contracts',
  templateUrl: './subcarrier-vendor-contracts.component.html',
  styleUrls: ['./subcarrier-vendor-contracts.component.scss'],
})
export class SubcarrierVendorContractsComponent implements OnInit {
  public createEdit$$ = new BehaviorSubject<SubcarrierVendorContracts | {}>(null);

  public subcarrierContracts$: Observable<SubcarrierVendorContracts[]>;

  public brokerTrailerTypes$ = this.subcarrierService.brokerTrailerTypes$;

  constructor(private subcarrierService: SubcarrierService) {
    this.subcarrierContracts$ = this.subcarrierService.subcarrierVendorContracts$;
    this.subcarrierService.getSubcarrierVendorContracts();
  }

  ngOnInit(): void {}

  public closeNewContractForm() {
    this.createEdit$$.next(null);
  }

  editContract(contract: SubcarrierVendorContracts) {
    this.createEdit$$.next(contract);
  }
}
